import FormGroup from '@mui/material/FormGroup'
import { IAccordionWithCheckboxesArgs } from './AccordionWithCheckboxes.types'
import Accordion from '../Accordion'
import { getAppliedCheckboxesAsArray } from './AccordionWithCheckboxes.helpers'
import {
  CheckboxLabel,
  FiltersCounter,
  LabeledCheckbox,
  OptionCheckbox
} from './AccordionWithCheckboxes.styles'
import useId from '../../../hooks/useId'

export const AccordionWithCheckboxes = ({
  options = {},
  onOptionToggle,
  withCounter = true,
  disabled = false,
  'data-testid': testid = 'accordion',
  ...accordionProps
}: IAccordionWithCheckboxesArgs) => {
  const { getTestId } = useId(testid)
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const handleToggle = (tagName: string) => (_: any, checked: boolean) =>
    onOptionToggle(tagName, checked)

  if (withCounter) {
    const appliedFiltersCount = getAppliedCheckboxesAsArray(options).length
    accordionProps.subtitle = (
      <FiltersCounter count={appliedFiltersCount}>
        {appliedFiltersCount}
      </FiltersCounter>
    )
  }
  return (
    <Accordion data-testid={getTestId()} {...accordionProps}>
      <FormGroup data-testid={getTestId('form-group')}>
        {Object.keys(options).map((optionKey) => {
          const { label, checked } = options[optionKey]
          return (
            <LabeledCheckbox
              labelPlacement="start"
              disabled={disabled}
              key={`checkbox-${label}`}
              onChange={handleToggle(label)}
              data-testid={getTestId(optionKey)}
              control={
                <OptionCheckbox
                  checked={checked}
                  data-testid={getTestId(`${optionKey}-input`)}
                />
              }
              label={
                <CheckboxLabel data-testid={getTestId(`${optionKey}-label`)}>
                  {label}
                </CheckboxLabel>
              }
            />
          )
        })}
      </FormGroup>
    </Accordion>
  )
}
